import BrowserWrapper from "@/components/apps/BrowserWrapper"
import Calculator from "@/components/apps/Calculator"
import Chat from "@/components/apps/Chat"
import FileManager from "@/components/apps/FileManager"
import Games from "@/components/apps/Games"
import MusicPlayer from "@/components/apps/MusicPlayer"
import Notes from "@/components/apps/Notes"
import Paint from "@/components/apps/Paint"
import FakeAntivirus from "@/components/apps/Antivirus"
import Settings from "@/components/apps/Settings"
import { AppType } from "@/lib/types"
import { SocketProvider } from "@/socket/socketContext"
import useMethodStore, { useMethodActions } from "@/store/MethodStore"
import { FaFolder, FaNoteSticky, FaPalette } from "react-icons/fa6";
import { IoChatbubble, IoGameControllerSharp, IoGlobeSharp, IoSettings, IoSettingsSharp, IoTerminalSharp } from "react-icons/io5";
import TerminalApp from "@/components/apps/Terminal"
import { PiMusicNotesFill } from "react-icons/pi"
import { IoIosCalculator } from "react-icons/io"
import { RiShieldUserFill } from "react-icons/ri"

function useApps() {

  const {
    setFilesState,
    setSettingsState,
    setBrowserState,
    setMusicState,
    setChatState,
    setPaintState,
    setNotesState,
    setCalculatorState,
    setLackShieldState,
    setGameState,
    setTerminalState,
  } = useMethodActions()

  const chatState = useMethodStore(state => state.chatState)
  const terminalState = useMethodStore(state => state.terminalState)
  const settingsState = useMethodStore(state => state.settingsState)
  const musicState = useMethodStore(state => state.musicState)
  const filesState = useMethodStore(state => state.filesState)
  const calculatorState = useMethodStore(state => state.calculatorState)
  const notesState = useMethodStore(state => state.notesState)
  const browserState = useMethodStore(state => state.browserState)
  const paintState = useMethodStore(state => state.paintState)
  const gameState = useMethodStore(state => state.gameState)
  const lackShieldState = useMethodStore(state => state.lackShieldState)

  const apps: AppType[] = [
    { name: "Files", minimalIcon: <FaFolder />, component: <FileManager />, state: filesState, setState: setFilesState, icon: <FaFolder className="text-blue-400 w-12" />, hasFullScreen: true, enableDrag: "lg" },
    { name: "Paint", minimalIcon: <FaPalette />, component: <Paint />, state: paintState, setState: setPaintState, icon: <img className="w-12" src="./apps/icons8-paint-48.png" />, hasFullScreen: true, enableDrag: "lg" },
    { name: "Settings", minimalIcon: <IoSettings />, component: <Settings />, state: settingsState, setState: setSettingsState, icon: <IoSettingsSharp className="text-gray-300 w-12" />, hasFullScreen: true, enableDrag: "lg" },
    { name: "Music", minimalIcon: <PiMusicNotesFill />, component: <MusicPlayer />, state: musicState, setState: setMusicState, icon: <img className="w-12" src="./apps/icons8-song-48.png" />, hasFullScreen: false, enableDrag: "md" },
    { name: "Notes", minimalIcon: <FaNoteSticky />, component: <Notes />, state: notesState, setState: setNotesState, icon: <img className="w-12" src="./apps/icons8-notes-32.png" />, hasFullScreen: false, enableDrag: "lg" },
    { name: "Calculator", minimalIcon: <IoIosCalculator />, component: <Calculator />, state: calculatorState, setState: setCalculatorState, icon: <img className="w-12" src="./apps/icons8-calculator-48.png" />, hasFullScreen: false, enableDrag: "md" },
    { name: "Browser", minimalIcon: <IoGlobeSharp />, component: <BrowserWrapper />, state: browserState, setState: setBrowserState, icon: <img className="w-12" src="./apps/icons8-browser-48.png" />, hasFullScreen: true, enableDrag: "lg" },
    { name: "Chat", minimalIcon: <IoChatbubble />, component: <SocketProvider><Chat /></SocketProvider>, state: chatState, setState: setChatState, icon: <img className="w-12" src="./apps/icons8-chat-48.png" />, hasFullScreen: false, enableDrag: "md" },
    { name: "Games", minimalIcon: <IoGameControllerSharp />, component: <Games />, state: gameState, setState: setGameState, icon: <img className="w-12" src="./apps/icons8-games-50.png" />, hasFullScreen: true, enableDrag: "lg" },
    { name: "Terminal", minimalIcon: <IoTerminalSharp />, component: <TerminalApp />, state: terminalState, setState: setTerminalState, icon: <img className="w-12" src="./apps/icons8-terminal-50.png" />, hasFullScreen: true, enableDrag: "lg" },
    { name: "LackShield", minimalIcon: <RiShieldUserFill />, component: <FakeAntivirus />, state: lackShieldState, setState: setLackShieldState, icon: <img className="w-12" src="./apps/icons8-shield-50.png" />, hasFullScreen: false, enableDrag: "lg" },
  ]

  return apps
}

export default useApps